import {Injectable} from '@angular/core';
import {GoogleTagManagerService} from 'angular-google-tag-manager';

const prefixesToExclude = ['AMP', 'intercom', 'uwPPCCookie'];

@Injectable({
  providedIn: 'root',
})
export class CustomGTMService extends GoogleTagManagerService {
  private isEnabled = true;

  setEnabled(enabled: boolean) {
    this.deleteCookies();
    this.isEnabled = enabled;
  }

  deleteCookies(excludedPrefixes: string[] = prefixesToExclude) {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const cookieName = cookie.split('=')[0].trim();
      const isExcluded = excludedPrefixes.some(prefix => cookieName.startsWith(prefix));

      if (isExcluded) {
        continue;
      }

      document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
    }
  }

  pushTag(tag: any): Promise<any> {
    if (!this.isEnabled) {
      console.info('GTM is disabled, tag not pushed:', tag);
      return Promise.resolve();
    }
    return super.pushTag(tag);
  }
}
